import { render, staticRenderFns } from "./TerritoryForm.vue?vue&type=template&id=8d2b56f0&"
import script from "./TerritoryForm.vue?vue&type=script&lang=js&"
export * from "./TerritoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports